'use client';

import type { ParentOrderInfo } from 'src/@types/historyTables';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import type { AmountDisplayType } from '../TradePageOrderHistoryTable';

interface FilledSizeCellProps {
	order: ParentOrderInfo;
	amountDisplayType: AmountDisplayType;
}

export function FilledSizeCell({
	order,
	amountDisplayType,
}: FilledSizeCellProps) {
	const { baseAssetAmountFilled, quoteAssetAmountFilled } = order;

	if (amountDisplayType === 'base') {
		return (
			<NumberDisplay
				value={baseAssetAmountFilled}
				type="number"
				precision="trade"
				isAccountValueToHide
				trimZeroes
			/>
		);
	}

	return (
		<NumberDisplay
			value={quoteAssetAmountFilled}
			type="currency"
			isAccountValueToHide
		/>
	);
}
